import {Component, signal, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {NgClass} from '@angular/common';

@Component({
  selector: 'peps-max-button',
	imports: [
		NgClass
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './max-button.component.html',
})
export class MaxButtonComponent {

	constructor(
		private readonly router: Router,
	) {}

	protected readonly isPokemonMenuOpen = signal(false);

	toOverwatch() {
		this.router.navigate(['/roster/overwatch/pro']);
	}

	toMarvelRivals() {
		this.router.navigate(['/roster/marvel-rivals']);
	}

	toDofus() {
		this.router.navigate(['/roster/dofus']);
	}

	protected toPokemonUnite() {
		this.router.navigate(['/roster/pokemon/unite']);
	}

	protected toPokemonVGC() {
		this.router.navigate(['/roster/pokemon/vgc']);
	}

	protected togglePokemonMenu() {
		this.isPokemonMenuOpen.update(isOpen => !isOpen);
	}
}
